import React from 'react';
import './schedule.scss';
import Breadcrumb from '../../shared/breadcrumb/breadcrumb.js';
import { useStore } from 'hooks/useStore';

export function Schedule() {
  const {
    state: {
      schedule: { doctors, rooms }
    }
  } = useStore();

  return (
    <main>
      <Breadcrumb
        links={[
          { to: '/', text: 'Главная' },
          { to: '/career', text: 'Вакансии' }
        ]}
      />
      {/* /breadcrumb */}

      <div className="container margin_60">
        <div className="main_title">
          <h1>График работы</h1>
        </div>
        <div>
          <div className="card add_bottom_45">
            <div className="card-body">
              <h2 className="add_bottom_30">График приёма врачей</h2>
              <div className="table-responsive">
                <table className="table table-hover add_bottom_45">
                  <thead>
                    <tr>
                      <th>Ф. И. О.</th>
                      <th>Занимаемая должность</th>
                      <th>Начало приёма</th>
                      <th>Обед</th>
                      <th>Окончание приёма</th>
                    </tr>
                  </thead>
                  <tbody>
                    {doctors.map(doctor =>
                      doctor.schedules.map((schedule, index) => (
                        <tr key={schedule.groupKey}>
                          <td>{index === 0 ? doctor.name : ''}</td>
                          <td>{schedule.groupKey}</td>
                          <td>{schedule.start}</td>
                          <td>{schedule.dinner}</td>
                          <td>{schedule.end}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              <h2 className="add_bottom_30">График работы кабинетов</h2>
              <div className="table-responsive">
                <table className="table table-hover add_bottom_45">
                  <thead>
                    <tr>
                      <th>Название</th>
                      <th>Кабинет</th>
                      <th>Время работы</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rooms.map(room => (
                      <tr key={room.id}>
                        <td>{room.name}</td>
                        <td>{room.id}</td>
                        <td>{room.workingHours}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <p>
                График работы врачей в учреждении утверждается ежемесячно.
                Просьба заранее уточнять необходимую информацию по телефону{' '}
                <a href="tel: +375165655011">
                  <strong>65-50-11</strong>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Schedule;
